import React, { Component } from "react";
import { Form, Button, Input, Grid, Message } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { auth } from "../actions";
import { withRouter } from "react-router-dom";

import Spinner from "./spinner";

class Login extends Component {
  state = {
    username: "",
    password: "",
    company_code: "",
    otp: "",
    remember: true,
    loading: false,
    showOTP: false,
    is2FARequired: false,
    errors: [],
  };

  onSubmit = async (e) => {
    e.preventDefault();

    const { username, password, company_code, otp, showOTP } = this.state;

    const formdata = new FormData();
    formdata.append("username", username);
    formdata.append("password", password);
    formdata.append("company_code", company_code);
    if (showOTP) formdata.append("totp_code", otp);

    this.setState({ loading: true, errors: [] });

    try {
      const response = await this.props.login(formdata);
      const detail = response?.data?.detail;

      // Show OTP input if backend says 2FA is required
      if (detail === "2FA_REQUIRED" && !showOTP) {
        this.setState({
          showOTP: true,
          is2FARequired: true,
          loading: false,
        });
        return;
      }

      // Login successful — now check is_2fa_enabled from final response
      const is2FAEnabled = response?.data?.user?.is_2fa_enabled;

      this.setState({ loading: false });

      if (is2FAEnabled) {
        this.props.history.push("/location");
      } else {
        this.props.history.push("/setup");
      }
    } catch (error) {
      this.setState({
        loading: false,
        errors: [
          {
            message: error.response?.data?.detail || "Login failed. Try again.",
          },
        ],
      });
    }
  };

  render() {
    const {
      username,
      password,
      company_code,
      otp,
      loading,
      showOTP,
      is2FARequired,
      errors,
    } = this.state;

    return (
      <Grid
        verticalAlign="middle"
        centered
        style={{
          height: "100vh",
          background: "#f7f8fa",
          border: "1px solid grey",
        }}
      >
        <Grid.Column style={{ maxWidth: 550 }}>
          <h2>Login</h2>
          <p style={{ color: "grey" }}>
            {showOTP
              ? "Check your authenticator or email for the 2FA code"
              : "Enter your email below to login to your account"}
          </p>

          {errors.length > 0 && (
            <Message negative>
              <Message.List>
                {errors.map((err, idx) => (
                  <Message.Item key={idx}>{err.message}</Message.Item>
                ))}
              </Message.List>
            </Message>
          )}

          <Form onSubmit={this.onSubmit}>
            {!showOTP && (
              <>
                <Form.Field>
                  <label>Username</label>
                  <Input
                    placeholder="Username"
                    value={username}
                    onChange={(e) =>
                      this.setState({ username: e.target.value })
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Password</label>
                  <Input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) =>
                      this.setState({ password: e.target.value })
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Company Code</label>
                  <Input
                    placeholder="Company Code"
                    value={company_code}
                    onChange={(e) =>
                      this.setState({ company_code: e.target.value })
                    }
                  />
                </Form.Field>
              </>
            )}

            {showOTP && (
              <Form.Field>
                <label>2FA Code</label>
                <Input
                  placeholder="Enter 6-digit code"
                  value={otp}
                  onChange={(e) => this.setState({ otp: e.target.value })}
                />
              </Form.Field>
            )}
            <br />

            <Button
              type="submit"
              fluid
              style={{ backgroundColor: "#18202f", color: "#fff" }}
              loading={loading}
            >
              {showOTP ? "Continue" : "Login"}
            </Button>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  login: (formdata) => dispatch(auth.login(formdata)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
